function getDescription (vm) {
  const { description } = vm.$options
  if (description) {
    return typeof description === 'function'
      ? description.call(vm)
      : description
  }
}
export default {
  created () {
    const description = getDescription(this)
    if (description) {
      if (document.querySelector('meta[name=description]')) {
        document.querySelector('meta[name=description]').setAttribute('content', description)
      } else {
        let meta = document.createElement('meta')
        meta.name = 'description'
        meta.content = description
        document.getElementsByTagName('head')[0].appendChild(meta)
      }
    }
  }
}
